module.exports = __webpack_public_path__ + "static/media/nflatbed.c4790215.webp";